export default (state, action) => {
  switch (action.type) {
    case 'USER_LOADING':
      return {
        ...state,
        isUserStateLoading: true
      };
    case 'USER_READY':
      return {
        user: action.payload,
        isUserStateLoading: false,
        isLoggedIn: !!action.payload.id,
        isAdmin: !!(action.payload.id && action.payload.role === 'Administrator'),
        isInternalUser: !!(action.payload.id &&( action.payload.role === 'External User')),
        heatmapSettings: action.payload.heatmapSettings,
        portfolios: action.payload.portfolios,
        holdings: action.payload.holdings,
        homepagePreference: action.payload.homepagePreferences?.route,
        peerGroups: action.payload.peerGroups,
        instruments: action.payload.instruments
      };

    case 'UPDATE_USER_HEATMAP_SETTINGS':
      return {
        ...state,
        heatmapSettings: action.payload
      };

    case 'UPDATE_USER_PORTFOLIO_SETTINGS':
      return {
        ...state,
        portfolios: action.payload
      };
    case 'UPDATE_USER_HOLDINGS_SETTINGS':
      return {
        ...state,
        holdings: action.payload
      };
    case 'UPDATE_USER_HOMEPAGE_PREFERENCE':
      return {
        ...state,
        homepagePreference: action.payload
      };
    case 'UPDATE_USER_PEER_GROUPS_SETTINGS':
      return {
        ...state,
        peerGroups: action.payload
      };
    case 'UPDATE_USER_INSTRUMENTS_SETTINGS':
      return {
        ...state,
        instruments: action.payload
      };
    default:
      return state;
  }
};
